import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=37503d6e&scoped=true&lang=html&"
import script from "./error-page.vue?vue&type=script&lang=js&"
export * from "./error-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37503d6e",
  null
  
)

export default component.exports